import * as React from 'react';

import { useOfferContext } from '../../../../context';
import { ChatOnboardingContainer } from '../ChatOnboardingContainer';
import { OfferChatButtonContainer } from '../OfferChatButtonContainer';

/**
 * Развилка для кнопок, открывающих разные виды чатов.
 */
export const ChatButtonContainer: React.FC = () => {
  const { isChatAvailable } = useOfferContext();

  if (isChatAvailable) {
    return (
      <ChatOnboardingContainer type="offerChatOnboarding">
        <OfferChatButtonContainer />
      </ChatOnboardingContainer>
    );
  }

  return null;
};
